import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { setCookie, getCookie, COOKIE_CONSENT_KEY } from "../../utils/cookies"

import '../../styles/common/cookie-banner.scss';


const CookieConsent = () => {
	// Default to true so that the banner doesn’t flash to people who have already acted on it.
	const [hasActedOnBanner, setHasActedOnBanner] = useState(true);
	const [hasApprovedCookies, setHasApprovedCookies] = useState(false);

	const getSixMonthsFromNow = () => {
		const sixMonthsFromNow = new Date();
		sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);
		sixMonthsFromNow.setFullYear(sixMonthsFromNow.getFullYear());
		return sixMonthsFromNow.toUTCString();
	};

	const acceptConsent = () => {
		setCookie(COOKIE_CONSENT_KEY, 'approved', 180);
		setHasApprovedCookies(true);
		setHasActedOnBanner(true);
	};

	const declineConsent = () => {
		setCookie(COOKIE_CONSENT_KEY, 'declined', 180);
		setHasApprovedCookies(false);
		setHasActedOnBanner(true);
	};

	useEffect(() => {
		const cookieConsent = getCookie(COOKIE_CONSENT_KEY);

		setHasActedOnBanner(cookieConsent.length > 0);
		setHasApprovedCookies(cookieConsent === 'approved');
	}, []);

	return <>
		{!hasActedOnBanner && (
			<div className="cookie-banner">
				<div className="page-width">
					<div className="cookie-banner__contents">
						<div className="message">
							This site uses essential cookies for some key site functionality. Would you also accept
							additional tracking cookies to help
							us learn how people are using the site? This use is minimal and doesn’t identify you as
							an
							individual.
						</div>
						<div className="actions">
							<button className="accept" onClick={acceptConsent}>Accept All</button>
							<button className="decline" onClick={declineConsent}>Decline Additional Cookies
							</button>
						</div>
					</div>
				</div>
			</div>
		)}
		{hasApprovedCookies && (
			<Helmet>
				<meta name="cookie-consent-test" content="test" />
				<script async src="https://www.googletagmanager.com/gtag/js?id=G-TF9LW7JQ3S"></script>
				<script>{`
					window.dataLayer = window.dataLayer || [];
					function gtag(){window.dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', 'G-TF9LW7JQ3S');
				`}</script>
				<script>{`
					(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','GTM-MDJJKZSX');
				`}</script>
			</Helmet>
		)}
	</>;
};

export default CookieConsent;